import React, { useContext, useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { useHistory, Link } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import commonContext from '@/product/context/common/commonContext'
import './Dashboard.css'
import Loaders from '@/product/components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'
import { greetingBasedOnTime } from '@/product/common/components'
import CustomTable from '@/product/components/molecules/CustomTable'
import { Doughnut } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
} from 'chart.js'
import { PointOfSale } from '@mui/icons-material'
import { useFormik } from 'formik'
import { mapData, dateFormatFunction } from '@/product/common/components'
import { Bar } from 'react-chartjs-2'
import Table from './Table'

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
)

const Dashboard = (props) => {
    const optionsBar = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    }

    const optionsPie = {
        plugins: {
            tooltip: {
                titleFont: {
                    size: 15,
                },
                bodyFont: {
                    size: 15,
                },
            },
            legend: {
                display: true,
                responsive: true,
                position: 'bottom',
                labels: {
                    pointStyle: 'circle',
                    usePointStyle: true,
                    padding: 15,
                    font: {
                        size: 12,
                    },
                },
                align: 'center',
            },
        },
    }
    const hue = 0
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const handleRedirect = (path) => {
        history.push(`/${path}`)
        window.scrollTo(0, 0)
    }
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const dashboardContext = useContext(commonContext)
    const {
        getMainDashboardData,
        mainDashboardData,
        getUserDashboardData,
        getSaleDashboardData,
        getLotDashboardData,
        userDashboardData,
        lotDashboardData,
        saleDashboardData,
        closeProductCount,
        getAllCountries,
        getAllStates,
        getPieDetails,
        pieDetails,
    } = dashboardContext
    const [getdashboard, setDashboard] = useState({
        activeCount: 0,
        draftCount: 0,
        onlyActiveCount: 0,
        relistCount: 0,
        soldbuynowCount: 0,
        unsoldCount: 0,
        bidCount: 0,
        paidCount: 0,
        paidUserCount: 0,
        saleCount: 0,
        soldProductdCount: 0,
        unSoldProductdCount: 0,
        totalTransaction: 0,
    })
    const [userdashboard, setUserboard] = useState({})
    const [saledashboard, setSaleboard] = useState({})
    const [timeOfDay, setTimeOfDay] = useState('Morning')
    const [barLabel, setBarLabel] = useState([])
    const [barData, setBarData] = useState([])
    const [filter, setFilter] = useState('all')
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [locations, setLocations] = useState([])

    const [selectedLocation, setSelectedLocation] = useState('All')
    const [chartLabel, setChartLabel] = useState({
        labels: [],
        datasets: [
            {
                label: 'City Population',
                data: [],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    })
    const [cities, setCities] = useState([])

    const [pieData, setPieData] = useState([])

    const chartData = {
        labels: chartLabel,
        datasets: [
            {
                label: 'User Location Data',
                data: pieData,
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#4BC0C0',
                    '#9966FF',
                    '#FF9F40',
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#4BC0C0',
                    '#9966FF',
                    '#FF9F40',
                ],
            },
        ],
    }

    const formik = useFormik({
        initialValues: {
            sale: 'day',
            user: 'day',
            lots: 'day',
            countries: 'country',
            ip_user: 'today',
            filterRange: true,
            search: 'within',
            within: 'month',
            single_date: dateFormatFunction(new Date()),
        },

        onSubmit: (values) => {},
    })
    const cardList = [
        {
            label: 'Active',
            count: getdashboard.activeCount,
            path: 'listing/open',
        },
        {
            label: 'Draft',
            count: getdashboard.draftCount,
            path: 'listing/draft',
        },
        {
            label: 'Sold',
            count: getdashboard.soldCount,
            path: 'listing/sold',
        },
        {
            label: 'Unsold',
            count: getdashboard.unsoldCount,
            path: 'listing/unsold',
        },
    ]

    const calulateFn = (data) => {
        let value = ''
        switch (formik.values[data]) {
            case 'day':
                value = ' Past 24 Hours'
                return value
            case 'week':
                value = 'Past 7 days'
                return value
            case 'month':
                value = 'Past 1 Month'
                return value
            case 'year':
                value = 'Past 1 Year'
                return value
            case 'today':
                value = 'Today'
                return value
            default:
                value = ' Past 24 Hours'
                return value
        }
    }
    const reportList = [
        {
            label: `Hammer Price - ${calulateFn('sale')}`,
            count: saledashboard.hammer_price_past_day,
            symbol: '$',
        },
        {
            label: `Hammer Price - ${calulateFn('sale')}  Average`,
            count: saledashboard.hammer_price_average,
            symbol: '$',
        },
        {
            label: `Bids Price- ${calulateFn('sale')}`,
            count: saledashboard.bids_price,
            symbol: '$',
        },
        {
            label: `Bids Count- ${calulateFn('sale')}`,
            count: saledashboard.bidCount,
        },
        {
            label: `Sales - ${calulateFn('sale')}`,
            count: saledashboard.saleCount,
        },
        {
            label: `Paid  Count Per Month`,
            count: saledashboard.paidCount,
        },
        {
            label: `Paid User Count Per Month `,
            count: saledashboard.paidUserCount,
        },
        {
            label: `Sold Product- ${calulateFn('sale')}`,
            count: saledashboard.soldProductdCount,
        },
        {
            label: `Unsold Product- ${calulateFn('sale')}`,
            count: saledashboard.unSoldProductdCount,
        },
        {
            label: `Total Transaction - ${calulateFn('sale')}`,
            count: saledashboard.totalTransaction,
            symbol: '$',
        },
    ]

    useEffect(() => {
        if (pieDetails?.userIpLocation && pieDetails?.userIpLocation?.length) {
            let label = []
            let data = []
            pieDetails.userIpLocation.map((elem) => {
                label.push(elem.name)
                data.push(elem.count)
            })

            setChartLabel(label)
            setPieData(data)
        } else {
            setChartLabel([])
            setPieData([])
        }
    }, [pieDetails])

    useEffect(() => {
        if (closeProductCount && closeProductCount.length) {
            let label = []
            let data = []
            closeProductCount.map((ele) => {
                label.push(ele.day)
                data.push(ele.closed_products_count)
            })

            setBarLabel(label)
            setBarData(data)
        }
    }, [closeProductCount])

    const staticLot = [
        {
            label: 'Total Lots',
            count: parseFloat(getdashboard.total_lots || 0).toFixed(0),
            path: 'listing/all',
        },
        {
            label: 'Live Lots',
            count: parseFloat(getdashboard.activeCount || 0).toFixed(0),
            path: 'listing/open',
        },
        {
            label: ' Total Assigned Lots',
            count: parseFloat(getdashboard.assigned_lots || 0).toFixed(0),
            path: 'listing/open',
        },
        {
            label: 'Inline Lots',
            count: parseFloat(getdashboard.assigned_draft_lots || 0).toFixed(0),
            path: 'listing/draft',
        },
        {
            label: 'Pending Lots',
            count: parseFloat(getdashboard.draftCount || 0).toFixed(0),
            path: 'listing/draft',
        },
        {
            label: `${calulateFn('lots')} -  Assigned Lots`,
            count: parseFloat(getdashboard.dynamic_assigned_lots || 0).toFixed(
                0
            ),
            path: 'listing/all',
        },
        {
            label: `${calulateFn('lots')} - Average Created Lot Count`,
            count: parseFloat(getdashboard.last_created_days || 0).toFixed(0),
            path: 'listing/all',
        },
        {
            label: `${calulateFn('lots')} - Average Sold Lot Count`,
            count: parseFloat(getdashboard.last_sold_days || 0).toFixed(0),
            path: 'listing/all',
        },
        {
            label: `Inventory Days (Total / ${calulateFn(
                'lots'
            )} Average Sold Lot)`,
            count: parseFloat(getdashboard.inventory_days_count || 0).toFixed(
                0
            ),
            path: 'listing/all',
        },
        {
            label: `% of Lots Inactive (Pending + Assigned / Total Lots)`,
            count: parseFloat(
                getdashboard.percentage_of_lot_inactive || 0
            ).toFixed(0),
            percentage: true,
            path: 'listing/all',
        },
    ]

    const staticUser = [
        {
            label: 'Active Users',
            count: parseFloat(userdashboard.active_users || 0).toFixed(0),
            path: 'users/active',
        },

        {
            label: 'Active Winners',
            count: parseFloat(userdashboard.active_users || 0).toFixed(0),
            path: 'users/active',
        },
        {
            label: 'Suspended Users',
            count: parseFloat(userdashboard.rejected_users || 0).toFixed(0),
            path: 'users/rejected',
        },
        {
            label: 'Deactivated Users',
            count: parseFloat(userdashboard.deactive_users || 0).toFixed(0),
            path: 'users/deactivate',
        },
        {
            label: `New Users - ${calulateFn('user')}`,
            count: parseFloat(userdashboard.dynamic_new_user || 0).toFixed(0),
            path: 'users/active',
        },
        {
            label: `New Winner - ${calulateFn('user')}`,
            count: parseFloat(userdashboard.dynamic_active_winner || 0).toFixed(
                0
            ),
            path: 'users/active',
        },
        {
            label: `Last Login - ${calulateFn('user')}`,
            count: parseFloat(userdashboard.dynamic_last_login || 0).toFixed(0),
            path: 'users/active',
        },
    ]

    useEffect(() => {
        setIsLoading(true)

        getMainDashboardData(formik.values)

        getAllCountries()
        getAllStates()
    }, [])

    useEffect(() => {
        const currentTime = new Date().getHours()

        if (currentTime >= 0 && currentTime < 12) {
            setTimeOfDay('Morning')
        } else if (currentTime >= 12 && currentTime < 18) {
            setTimeOfDay('Afternoon')
        } else {
            setTimeOfDay('Evening')
        }
    }, [])

    useEffect(() => {
        setIsLoading(false)
        if (Object.keys(mainDashboardData).length > 0) {
            setDashboard({ ...getdashboard, ...mainDashboardData })
        }
    }, [mainDashboardData])
    useEffect(() => {
        setIsLoading(false)
        if (userDashboardData && Object.keys(userDashboardData).length > 0) {
            setUserboard(userDashboardData)
        }
    }, [userDashboardData])
    useEffect(() => {
        setIsLoading(false)
        if (saleDashboardData && Object.keys(saleDashboardData).length > 0) {
            setSaleboard(saleDashboardData)
        }
    }, [saleDashboardData])
    useEffect(() => {
        setIsLoading(false)
        if (lotDashboardData && Object.keys(lotDashboardData).length > 0) {
            setDashboard({ ...mainDashboardData, ...lotDashboardData })
        }
    }, [lotDashboardData])

    useEffect(() => {
        if (formik.values.lots) {
            getLotDashboardData(formik.values)
        }
    }, [formik.values.lots])
    useEffect(() => {
        if (formik.values.user) {
            getUserDashboardData(formik.values)
        }
    }, [formik.values.user])
    useEffect(() => {
        if (formik.values.sale) {
            getSaleDashboardData(formik.values)
        }
    }, [formik.values.sale])

    useEffect(() => {
        if (formik.values.ip_user) {
            getPieDetails(formik.values)
        }
    }, [formik.values.ip_user])

    const doughnutData = {
        labels: barLabel,
        datasets: [
            {
                label: '# of Users',
                data: pieData,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderWidth: 1,
            },
        ],
    }

    const options = {
        plugins: {
            tooltip: {
                titleFont: {
                    size: 15,
                },
                bodyFont: {
                    size: 15,
                },
            },
            legend: {
                display: true,
                responsive: true,
                position: 'bottom',
                labels: {
                    pointStyle: 'circle',
                    usePointStyle: true,
                    // boxWidth: 36,
                    padding: 15,
                    font: {
                        size: 12,
                    },
                },
                align: 'center',
            },
        },
    }
    const optionsValues = [
        { value: 'today', show: 'Today' },
        { value: 'day', show: ' Past 24 Hours' },
        { value: 'week', show: 'Past 7 days' },
        { value: 'month', show: 'Past 1 Month' },
        { value: 'year', show: 'Past 1 Year' },
    ]

    const optionsValuesCountries = [
        { value: 'all', show: 'All' },
        { value: 'today', show: 'Today' },
        { value: 'day', show: ' Past 24 Hours' },
        { value: 'week', show: 'Past 7 days' },
        { value: 'month', show: 'Past 1 Month' },
        { value: 'year', show: 'Past 1 Year' },
    ]
    const saleWithinRange = [
        {
            label: 'Sales Period',
            placeholder: 'Enter Within',
            class: 'col-3',
            type: 'select',
            options: optionsValues,
            name: 'sale',
            formik: formik,
        },
    ]
    const userWithinRange = [
        {
            label: 'User Period',
            placeholder: 'Enter Within',
            class: 'col-3',
            type: 'select',
            options: optionsValues,
            name: 'user',
            formik: formik,
        },
    ]

    const lotsWithinRange = [
        {
            label: 'Lots Period',
            placeholder: 'Enter Within',
            class: 'col-3',
            type: 'select',
            options: optionsValues,
            name: 'lots',
            formik: formik,
        },
    ]

    const pieChartData = [
        {
            label: 'Filter',
            placeholder: 'Enter Within',
            class: 'col-3',
            type: 'select',
            options: optionsValuesCountries,
            name: 'ip_user',
            formik: formik,
        },
    ]

    const dataBar = {
        labels: barLabel,
        datasets: [
            {
                label: 'Closing Product',
                data: barData,
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
        ],
    } //Setting dataBar

    return (
        <Layout>
            <div>
                {greetingBasedOnTime(
                    `${
                        user?.emp_firstname
                            ? user?.emp_firstname
                            : null + ' ' + user?.emp_lastname
                            ? user?.emp_lastname
                            : null
                    }`,
                    'Welcome to your Dashboard'
                )}
            </div>
            <div className="mt-2 mb-2 text-left">
                <Link to="/listing/new/0" className="add-inventory-btn">
                    {props?.auctionTitle ? props.auctionTitle : 'Add Inventory'}
                </Link>
            </div>

            <div className="dashboard">
                <h4 className="dcTitle">Products</h4>
                <div className="dashboardCard">
                    {cardList.map((data, index) => (
                        <div
                            key={index}
                            className="infoCard"
                            style={{
                                background: `linear-gradient(127deg, rgba(222,226,255,1) 0%, rgba(214,254,245,1) 100%)`,
                                filter: `hue-rotate(${hue + index * 100}deg)`,
                            }}
                        >
                            <Button
                                id="dashboard_count"
                                onClick={() => handleRedirect(data.path)}
                            >
                                <div className="icInner">
                                    <svg
                                        width="53"
                                        height="53"
                                        viewBox="0 0 53 53"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width="53"
                                            height="53"
                                            rx="16"
                                            fill="white"
                                        />
                                        <path
                                            d="M29.4743 35.6726C28.5554 36.398 27.4431 36.7849 26.2341 36.7849C25.025 36.7849 23.8643 36.3497 22.9938 35.6726H14.6272V39.1547C14.6272 39.4448 14.869 39.6383 15.1108 39.6383H37.8893C38.1311 39.6383 38.3729 39.4448 38.3729 39.1547V35.6726H29.4743Z"
                                            fill="#333333"
                                        />
                                        <path
                                            d="M14.6271 23.5822V34.7054H22.0265C21.3495 33.8349 20.9626 32.7226 20.9626 31.5619C20.9626 28.6602 23.3323 26.2904 26.234 26.2904C29.1357 26.2904 31.5055 28.6602 31.5055 31.5619C31.5055 32.7709 31.1186 33.8349 30.4415 34.7054H38.3729V23.5822L41.8549 20.1001C42.0484 19.9067 42.0484 19.6165 41.8549 19.423C41.6615 19.2296 41.3713 19.2296 41.1778 19.423L37.6958 22.9051H15.3042L11.8222 19.423C11.6287 19.2296 11.3385 19.2296 11.1451 19.423C10.9516 19.6165 10.9516 19.9067 11.1451 20.1001L14.6271 23.5822Z"
                                            fill="#333333"
                                        />
                                        <path
                                            d="M30.4898 31.5619C30.4898 29.1922 28.5553 27.2577 26.1856 27.2577C23.8158 27.2577 21.8813 29.1922 21.8813 31.5619C21.8813 33.9316 23.8158 35.8661 26.1856 35.8661C28.6037 35.8661 30.4898 33.9316 30.4898 31.5619ZM25.315 33.4964C25.17 33.4964 25.0732 33.448 24.9765 33.3513L23.8158 32.1906C23.6224 31.9972 23.6224 31.707 23.8158 31.5135C24.0093 31.3201 24.2994 31.3201 24.4929 31.5135L25.315 32.3357L27.9266 29.7241C28.12 29.5307 28.4102 29.5307 28.6037 29.7241C28.7971 29.9176 28.7971 30.2078 28.6037 30.4012L25.7019 33.3029C25.6052 33.448 25.4601 33.4964 25.315 33.4964Z"
                                            fill="#333333"
                                        />
                                        <path
                                            d="M19.0281 15.0221L19.4633 14.5868V20.3903C19.4633 20.6804 19.6568 20.8739 19.947 20.8739C20.2371 20.8739 20.4306 20.6804 20.4306 20.3903V14.5868L20.8658 15.0221C21.0593 15.2155 21.3495 15.1672 21.5429 14.9737C21.7364 14.7803 21.688 14.4901 21.4945 14.2967L20.2371 13.136C20.0921 12.9909 19.8502 12.9425 19.6568 13.0876C19.6084 13.0876 19.6084 13.136 19.5601 13.136L18.3027 14.2967C18.1092 14.4901 18.1092 14.7803 18.2543 14.9737C18.4961 15.2155 18.7863 15.2155 19.0281 15.0221Z"
                                            fill="#333333"
                                        />
                                        <path
                                            d="M25.5569 15.0221L25.9922 14.6352V20.4386C25.9922 20.7288 26.1856 20.9223 26.4758 20.9223C26.7659 20.9223 26.9594 20.7288 26.9594 20.4386V14.6352L27.3947 15.0705C27.5881 15.2639 27.8783 15.2156 28.0717 15.0221C28.2652 14.8287 28.2168 14.5385 28.0234 14.345L26.7659 13.1844C26.5725 12.9909 26.2823 13.0393 26.0889 13.1844L24.8315 14.345C24.638 14.5385 24.638 14.8287 24.7831 15.0221C25.0249 15.2156 25.3634 15.2156 25.5569 15.0221Z"
                                            fill="#333333"
                                        />
                                        <path
                                            d="M32.0857 15.0221L32.521 14.5869V20.3903C32.521 20.6805 32.7144 20.8739 33.0046 20.8739C33.2948 20.8739 33.4882 20.6805 33.4882 20.3903V14.5869L33.9235 15.0221C34.1169 15.2156 34.4071 15.1672 34.6005 14.9738C34.794 14.7803 34.7456 14.4901 34.5522 14.2967L33.2948 13.136C33.1013 12.9426 32.8111 12.9909 32.6177 13.136L31.3603 14.2967C31.1668 14.4901 31.1668 14.7803 31.3119 14.9738C31.5537 15.2156 31.8923 15.2156 32.0857 15.0221Z"
                                            fill="#333333"
                                        />
                                    </svg>

                                    <div>
                                        <h3>{data.count}</h3>
                                        <h6>{data.label}</h6>
                                    </div>
                                </div>
                            </Button>
                        </div>
                    ))}
                </div>
                <div style={{ height: '500px' }}>
                    <Bar options={optionsBar} data={dataBar} />
                </div>
                <div className="biddingCnt d-flex justify-content-between align-items-start flex-wrap mt-3">
                    <h5>User Statistics</h5>
                    {Object.values(mapData(pieChartData))}
                </div>
                <div className="dropdown-container" style={{ height: '500px' }}>
                    {pieData.length > 0 ? (
                        <Doughnut data={chartData} options={optionsPie} />
                    ) : (
                        <p>No data available</p>
                    )}
                </div>
                {/* <div className="dashGraphicalStats">
                    <div className="dashSales">
                        <h4 className="dcTitle mb-3">Average Sales</h4>
                        <CustomTable
                            formik={dummyFormik}
                            tableBody={dummyTableBody}
                            tableValues={dummyTableValues}
                            tableActions={dummyTableActions}
                            allData={dummyData}
                            // isLoading={isLoading}
                            loadingTemplate={'table'}
                            // changeTableFunction={getAllInvoices}
                        />
                    </div>
                    <div className="dashUsers">
                        <h4 className="dcTitle mb-3">Users</h4>

                        <div className="dashUsersInner">
                            <Doughnut data={doughnutData} options={options} />
                        </div>
                    </div>
                </div> */}

                {/* <h4 className="dcTitle">Transactions Per Month</h4>
                <div className="dashboardCard">
                    {reportList.map((data, index) => (
                        <div key={index} className="infoCard secInfoCards">
                            <Button id="dashboard_count">
                                <h3>
                                    {`${data.symbol ? data.symbol : ''}`}{' '}
                                    {data.count}
                                </h3>
                                <h6
                                // style={{
                                //     filter: `hue-rotate(${
                                //         hue + index * 50
                                //     }deg)`,
                                // }}
                                >
                                    {data.label}
                                </h6>
                            </Button>
                        </div>
                    ))}
                </div> */}
                {/* <Table pieDetails={pieDetails} type="browser" />
                <Table pieDetails={pieDetails} type="device" /> */}

                <div className="biddingCnt d-flex justify-content-between align-items-start flex-wrap mt-3">
                    <h4 className="dcTitle mt-4">Lotting and Inventory</h4>
                    {Object.values(mapData(lotsWithinRange))}
                </div>
                <div className="dashboardCard">
                    {staticLot.map((data, index) => (
                        <div key={index} className="infoCard secInfoCards">
                            <Button
                                id="dashboard_count"
                                onClick={() => handleRedirect(data.path)}
                            >
                                <h3>
                                    {`${data.symbol ? data.symbol : ''}`}{' '}
                                    {data.count || 0}
                                </h3>
                                <h6
                                // style={{
                                //     filter: `hue-rotate(${
                                //         hue + index * 50
                                //     }deg)`,
                                // }}
                                >
                                    {data.label}
                                    {`${data.percentage ? '%' : ''}`}
                                </h6>
                            </Button>
                        </div>
                    ))}
                </div>
                <div className="biddingCnt d-flex justify-content-between align-items-start flex-wrap mt-3">
                    <h4 className="dcTitle mt-4">Sales and Pickup center</h4>
                    {Object.values(mapData(saleWithinRange))}
                </div>
                <div className="dashboardCard">
                    {reportList.map((data, index) => (
                        <div key={index} className="infoCard secInfoCards">
                            <Button
                                id="dashboard_count"
                                onClick={() => handleRedirect('invoice/all')}
                            >
                                <h3>
                                    {`${data.symbol ? data.symbol : ''}`}{' '}
                                    {data.count ? data.count : 0}
                                </h3>
                                <h6
                                // style={{
                                //     filter: `hue-rotate(${
                                //         hue + index * 50
                                //     }deg)`,
                                // }}
                                >
                                    {data.label}
                                    {`${data.percentage ? '%' : ''}`}
                                </h6>
                            </Button>
                        </div>
                    ))}
                </div>

                {user?.emp_type === 'super_admin' ||
                user?.emp_type === 'admin' ? (
                    <>
                        <div className="biddingCnt d-flex justify-content-between align-items-start flex-wrap mt-3">
                            <h4 className="dcTitle mt-4"> User Growth</h4>
                            {Object.values(mapData(userWithinRange))}
                        </div>
                        <div className="dashboardCard">
                            {staticUser.map((data, index) => (
                                <div
                                    key={index}
                                    className="infoCard secInfoCards"
                                >
                                    <Button
                                        id="dashboard_count"
                                        onClick={() =>
                                            handleRedirect(data.path)
                                        }
                                    >
                                        <h3>
                                            {`${
                                                data.symbol ? data.symbol : ''
                                            }`}{' '}
                                            {data.count ? data.count : 0}
                                        </h3>
                                        <h6
                                        // style={{
                                        //     filter: `hue-rotate(${
                                        //         hue + index * 50
                                        //     }deg)`,
                                        // }}
                                        >
                                            {data.label}{' '}
                                            {`${data.percentage ? '%' : ''}`}
                                        </h6>
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </>
                ) : null}
            </div>
        </Layout>
    )
}

export default Dashboard
